import React from "react";
import { Col, Row } from "reactstrap";

const ImmunizationDetails = () => {
  return (
    <div style={{ width: "50vw", paddingLeft: "24px", paddingRight: "12px" }}>
      <div>
        <Row className="mb-3">
          <Col md="4">
            <div className="invHeadDetails">Vaccine Name</div>
            <div className="inv-details">Flucevax 2024-2025 Pf 0.5ml</div>
          </Col>
          <Col md="4">
            <div className="invHeadDetails">Administration Date</div>
            <div className="inv-details">9/25/2024</div>
          </Col>
          <Col md="4">
            <div className="invHeadDetails">Dose</div>
            <div className="inv-details">1</div>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md="4">
            <div className="invHeadDetails">
              Administering Pharmacy Location
            </div>
            <div className="inv-details">Store #055</div>
          </Col>
          <Col md="4">
            <div className="invHeadDetails">Lot Number</div>
            <div className="inv-details">123456789</div>
          </Col>
          <Col md="4">
            <div className="invHeadDetails">Site</div>
            <div className="inv-details">XXXX</div>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md="4">
            <div className="invHeadDetails">Route</div>
            <div className="inv-details">XXXX</div>
          </Col>
          <Col md="4">
            <div className="invHeadDetails">Administrator</div>
            <div className="inv-details">XXXX</div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ImmunizationDetails;
